// Lodash
import { get } from 'lodash';

// STORE ACTION AND STATE
import { Actions, ActionTypes } from './actions';
import { AuthState, initialState } from './state';

/**
 * This reducer is for store data using actions.
 * For auth data store purpose.
 *
 * @author Pratik Shihora <pratik@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 16/03/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) initially create ruducer with few actions
 * Date: 15/04/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) added login actions
 * Date: 02/05/2020 (Pratik Shihora <pratik@saeculumsolutions.com>) added logout actions
 */
export function reducer(state = initialState, action: Actions): AuthState {
  switch (action.type) {
    // AUTH COMMON METHOD
    case ActionTypes.AUTH_COMMON: {
      return state;
    }
    // AUTH_COMMON_SUCCESS COMMON METHOD
    case ActionTypes.AUTH_COMMON_SUCCESS: {
      // commonly store and handle all auth modules
      return {
        ...state,
        [action.response.common.STATE]: get(action.response.data, action.response.common.API_RESPONSE),
      };
    }
    // LOGIN METHOD
    case ActionTypes.LOGIN: {
      return state;
    }
    // LOGIN_SUCCESS METHOD
    case ActionTypes.LOGIN_SUCCESS: {
      return {
        ...state,
        user: action.response.data,
      };
    }

    case ActionTypes.UPDATE_PROFILE_DETAILS_SUCCESS: {
      if (state && state.user && state.user.employee_id && action && action.response
        && action.response.data && action.response.data.data && action.response.data.data.employees
        && action.response.data.data.employees.employee_id && action.response.data.data.employees.employee_id === state.user.employee_id) {
        return {
          ...state,
          user: {
            ...state.user,
            ...action.response.data.data.employees,
          },
        };
      } else {
        return state;
      }

    }
    // LOGOUT METHOD
    case ActionTypes.LOGOUT: {
      return state;
    }
    // LOGOUT_SUCCESS METHOD
    case ActionTypes.LOGOUT_SUCCESS: {
      console.log('logout')
      return initialState;
    }

    // CLEAR_REDUCER METHOD ON LOGOUT
    case ActionTypes.CLEAR_REDUCER: {
      console.log('logout')
      return initialState;
    }
    // DEFAULT
    default:
      return state;
  }
}
